import React from 'react';
import ReactDOM from 'react-dom/client';
import axios from 'axios';

import './tailwind.css';
import './styles/index.scss';

import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';

import App from './App';

import './i18n';

// Echo the (non-httpOnly) CSRF cookie back in a header on POST/PUT/DELETE calls
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);
